import { FC } from 'react'
import { SvgProps } from './svgProps'

const FacebookCircleIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    width={width || 19}
    height={height || 19}
    viewBox="0 0 19 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="web" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="assety"
        transform="translate(-316.000000, -497.000000)"
        fill={color || '#FFF'}
        fillRule="nonzero"
      >
        <g id="Group-6" transform="translate(291.000000, 488.000000)">
          <g id="ic_facebook_share" transform="translate(25.000000, 9.000000)">
            <path
              d="M9.50005666,0 C4.25337445,0 0,4.27115639 0,9.53977324 C0,14.265107 3.42495691,18.178475 7.91563728,18.9362718 L7.91563728,11.5300283 L5.62394651,11.5300283 L5.62394651,8.8648231 L7.91563728,8.8648231 L7.91563728,6.89960409 C7.91563728,4.6193856 9.30252838,3.37679909 11.3284682,3.37679909 C12.2987707,3.37679909 13.1326279,3.44940375 13.3746936,3.48138166 L13.3746936,5.86481711 L11.9695569,5.86549991 C10.8680222,5.86549991 10.6556481,6.39103013 10.6556481,7.162483 L10.6556481,8.8634575 L13.2840323,8.8634575 L12.9412193,11.5286627 L10.6556481,11.5286627 L10.6556481,19 C15.3559828,18.4255356 19,14.4124785 19,9.53704203 C19,4.27115639 14.7466256,0 9.50005666,0 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default FacebookCircleIcon
